import { render, staticRenderFns } from "./OView.vue?vue&type=template&id=cf241334&"
import script from "./OView.vue?vue&type=script&lang=ts&"
export * from "./OView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports